<template>
    <div class="embed-code">
        <embed-section
            title="Javascript"
            :script="embedScript"
        />
        <embed-section
            v-if="! player.sticky"
            title="iframe"
            :script="embedIframe"
        />
        <p class="embed-text">
            Not sure which embed code is right for your website? <a class="external-link" href="https://support.fusebox.fm/article/451-javascript-vs-iframe" target="_blank">Click here </a>to learn more
        </p>
    </div>
</template>
<script>
import EmbedSection from '@/components/Embed/EmbedSection';
import { getEmbedScriptTag, getEmbedIframeTag } from '@/utils/embedTags';

export default {
    components: {
        EmbedSection,
    },

    props: {
        player: {
            type: Object,
            required: true,
        },
        show: {
            type: Object,
            required: true,
        },
        playerType: {
            type: String,
            required: true,
        },
        trackGuid: {
            type: String,
            default: null,
        },
        trackNo: {
            type: String,
            default: '1:0',
        },
    },

    computed: {
        /**
         * Returns script to embed.
         *
         * @returns {string} Script HTML tag.
         */
        embedScript() {
            return getEmbedScriptTag(this.playerType, this.player, this.show, this.trackNo, this.trackGuid);
        },

        /**
         * Returns iframe to embed.
         *
         * @returns {string} Iframe HTML tag.
         */
        embedIframe() {
            return getEmbedIframeTag(this.$appUrl, this.playerType, this.player, this.show, this.trackNo, this.trackGuid);
        },
    },
};
</script>
